import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SimpleBarScroll from "components/SimpleBar";
import LocationCreate from "pages/inventory/location/LocationCreate";
import React from "react";

const LocationDialog = ({ open, handleClose, location }) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Edit location"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <Box padding={2}>
            <LocationCreate location={location} fullGrid={true} />
          </Box>
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  );
};

export default LocationDialog;
